import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Clinic } from '@models/clinic';
import { Tag } from '@models/tag/tag';
import { ClinicsService } from '@services/clinics.service';
import { TagService } from '@services/tag.service';

@Component({
  selector: 'app-org-online-general-settings',
  templateUrl: './org-online-general-settings.component.html',
  styleUrls: ['./org-online-general-settings.component.less'],
})
export class OrgOnlineGeneralSettingsComponent implements OnInit {
  private _clinic: Clinic;
  @Input() set clinic(clinic: Clinic) {
    this._clinic = clinic;
    this.initForm();
  }
  get clinic(): Clinic {
    return this._clinic;
  }
  loading = false;
  form: FormGroup;
  photoSections: Tag[] = [];

  constructor(private fb: FormBuilder, private clinicsService: ClinicsService, private tagService: TagService) {}

  ngOnInit(): void {
    this.tagService.getExternalPhotoTags().subscribe((res) => {
      this.photoSections = res.Service;
    });
  }

  initForm() {
    this.form = this.fb.group({
      sendPatientPortalEmail: this.clinic?.sendPatientPortalEmail == null ? false : this.clinic.sendPatientPortalEmail,
      defaultPortalPhotoTagId: [this.clinic?.defaultPortalPhotoTagId],
      onlineBookingBufferHours: [
        this.clinic?.onlineBookingBufferHours ? this.clinic.onlineBookingBufferHours : 0,
        Validators.required,
      ],
      onlineBookingAllowSameDay: [
        this.clinic?.onlineBookingAllowSameDay ? this.clinic.onlineBookingAllowSameDay : false,
      ],
      onlineBookingCancellationPeriodHours: [
        this.clinic?.onlineBookingCancellationPeriodHours ? this.clinic.onlineBookingCancellationPeriodHours : 0,
        Validators.required,
      ],
      onlineBookingCanCancelAppointment: [
        this.clinic?.onlineBookingCanCancelAppointment ? this.clinic.onlineBookingCanCancelAppointment : false,
      ],
      onlineBookingAppointmentLimit: [
        this.clinic?.onlineBookingAppointmentLimit ? this.clinic.onlineBookingAppointmentLimit : 0,
        Validators.required,
      ],
      onlineBookingCancellationPrice: [
        this.clinic?.onlineBookingCancellationPrice ? this.clinic.onlineBookingCancellationPrice : 0,
        Validators.required,
      ],
      checkPrerequisiteValidity: [
        this.clinic?.checkPrerequisiteValidity ? this.clinic.checkPrerequisiteValidity : false,
      ],
      prerequisiteValidityPeriod: [
        this.clinic?.prerequisiteValidityPeriod ? this.clinic.prerequisiteValidityPeriod : 0,
        Validators.required,
      ],
      onlineBookingReservationDurationMinutes: [
        this.clinic?.onlineBookingReservationDurationMinutes ?? 5,
        Validators.required,
      ],
    });
  }

  updateSettings() {
    this.loading = true;
    this.clinicsService.getClinicById(this.clinic.clinicId).subscribe((clinic) => {
      clinic.sendPatientPortalEmail = this.form.get('sendPatientPortalEmail').value;
      clinic.defaultPortalPhotoTagId = this.form.get('defaultPortalPhotoTagId').value;
      clinic.onlineBookingAppointmentLimit = this.form.get('onlineBookingAppointmentLimit').value;
      clinic.onlineBookingBufferHours = this.form.get('onlineBookingBufferHours').value;
      clinic.onlineBookingAllowSameDay = this.form.get('onlineBookingAllowSameDay').value;
      clinic.onlineBookingCancellationPeriodHours = this.form.get('onlineBookingCancellationPeriodHours').value;
      clinic.onlineBookingCanCancelAppointment = this.form.get('onlineBookingCanCancelAppointment').value;
      clinic.onlineBookingCancellationPrice = this.form.get('onlineBookingCancellationPrice').value;
      clinic.checkPrerequisiteValidity = this.form.get('checkPrerequisiteValidity').value;
      clinic.prerequisiteValidityPeriod = this.form.get('prerequisiteValidityPeriod').value;
      clinic.onlineBookingReservationDurationMinutes = this.form.get('onlineBookingReservationDurationMinutes').value;
      this.clinicsService.updateClinicBookingSettings(clinic).subscribe(() => {
        this.form.markAsPristine();
        this.loading = false;
      });
    });
  }

  resetSettings() {
    this.initForm();
    this.form.markAsPristine();
  }
}
